// src/app/services/adminKyc.js
import http, { API_BASE_URL } from "../api/http.js";

/**
 * List KYC submissions for admin review
 */
export async function adminListKycSubmissions(params = {}) {
  // ✅ Correct: http base URL already has /api
  const res = await http.get("/admin/kyc/submissions", { params });
  return res.data;
}

/**
 * Approve a KYC submission
 */
export async function adminApproveKyc(userId, note = null) {
  // ✅ Correct: no /api prefix needed
  const res = await http.post(`/admin/kyc/submissions/${userId}/approve`, { note });
  return res.data;
}

/**
 * Reject a KYC submission
 */
export async function adminRejectKyc(userId, reason) {
  // ✅ Correct: no /api prefix needed
  const res = await http.post(`/admin/kyc/submissions/${userId}/reject`, { reason });
  return res.data;
}

/**
 * Get KYC file URL for viewing
 */
export function getAdminKycFileUrl(filename) {
  if (!filename) return '';
  if (filename.startsWith('http://') || filename.startsWith('https://')) {
    return filename;
  }
  // ✅ Correct: API_BASE_URL already includes /api
  return `${API_BASE_URL}/admin/kyc/files/${encodeURIComponent(filename)}`;
}

export default {
  adminListKycSubmissions,
  adminApproveKyc,
  adminRejectKyc,
  getAdminKycFileUrl,
};
